import { render, staticRenderFns } from "./BaseBreadCrumbs.vue?vue&type=template&id=0a79186b&scoped=true"
import script from "./BaseBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BaseBreadCrumbs.vue?vue&type=script&lang=js"
import style0 from "./BaseBreadCrumbs.vue?vue&type=style&index=0&id=0a79186b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79186b",
  null
  
)

export default component.exports